"use strict";
import { ActivityStream } from "../accounts_payable/activity_streams";
export default {
  invoiceActivity: function(activityItems) {
    return /* @__PURE__ */ React.createElement(
      ActivityStream,
      {
        items: activityItems
      }
    );
  }
};
